import useSWR from "swr";
import { fetchSidecar } from "~/lib/client/endilApiCalls";

/** Hook to fetch sidecar by postId */
export const useSidecarContent = ({ postId }: { postId: string | number }) =>
  useSWR(
    ["sidecar", postId],
    () => fetchSidecar({ postId }).then(({ data }) => data),
    {
      revalidateIfStale: false,
      revalidateOnFocus: false,
      revalidateOnMount: true,
      revalidateOnReconnect: false,
    }
  );
